import { ref, onMounted } from 'vue'
import { api } from '@/composables/api'
import type { School } from '@/types/School'

export function useSchools() {
  const schools = ref<School[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)

  const loadSchools = async (county?: string) => {
    loading.value = true
    error.value = null
    try {
      const params = county ? { county } : {}
      const response = await api.get('/schools', params)
      schools.value = response.data || response
    } catch (err) {
      console.error('Error loading schools:', err)
      error.value = 'Failed to load schools'
      schools.value = []
    } finally {
      loading.value = false
    }
  }

  // Format schools for v-select
  const schoolOptions = ref<Array<{title: string, value: string}>>([])

  const updateSchoolOptions = () => {
    schoolOptions.value = schools.value.map(school => ({
      title: school.name,
      value: school.id
    }))
  }

  const searchSchools = async (query: string) => {
    if (!query || query.length < 2) return []

    try {
      const response = await api.get('/schools/search', { q: query })
      return response.data || response
    } catch (err) {
      console.error('Error searching schools:', err)
      return []
    }
  }

  const getSchoolById = async (id: string): Promise<School | null> => {
    try {
      const response = await api.get(`/schools/${id}`)
      return response.data || response
    } catch (err) {
      console.error('Error fetching school:', err)
      return null
    }
  }

  return {
    schools,
    schoolOptions,
    loading,
    error,
    loadSchools,
    updateSchoolOptions,
    searchSchools,
    getSchoolById
  }
}
